import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '@env/env';
import {AuthService} from '../../auth/auth.service';
import {UpdatedUserPayload, UpdatePasswordPayload} from './models/profile.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  CHECKOUT_API_URL = environment.CHECKOUT_API_URL;

  constructor(
    private _http: HttpClient,
    private authService: AuthService,
  ) {}

  getUserByKeycloakId() {
    return this._http.get<any>(`${this.CHECKOUT_API_URL}/user/account`, {
      headers: this.authService.getAccessToken(),
    });
  }

  updateAccount(payload: UpdatedUserPayload): Observable<any> {
    return this._http.patch<any>(`${this.CHECKOUT_API_URL}/user/account`, payload, {
      headers: this.authService.getAccessToken(),
    });
  }

  updatePassword(payload: UpdatePasswordPayload): Observable<any> {
    return this._http.patch<any>(`${this.CHECKOUT_API_URL}/user/update-password`, payload, {
      headers: this.authService.getAccessToken(),
    });
  }
}
